import { OutputId } from "../../idTypeBrands.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";
import { OutputContent } from "../AppSessionEventState.js";

export const REPLACE_OUTPUT_CONTENTS = createAppSessionEventDefinition({
  type: "REPLACE_OUTPUT_CONTENTS",
  logSafe: { outputId: true, outputContents: false },
  create: (payload: {
    outputId: OutputId;
    outputContents: Omit<OutputContent, "outputId">[];
  }) => payload,
  apply: (previousState, { outputContents, outputId }) => {
    const warnings: string[] = [];

    if (previousState.outputs[outputId] == null) {
      warnings.push(`Output not found: ${outputId}`);
    }

    for (const outputContent of Object.values(previousState.outputContents)) {
      if (outputContent.outputId === outputId) {
        delete previousState.outputContents[outputContent.id];
      }
    }

    for (const outputContent of outputContents) {
      previousState.outputContents[outputContent.id] = {
        ...outputContent,
        outputId,
      };
    }

    return { warnings };
  },
});
